<script setup>
import BlogHeadline from '~/components/blocks/two-six/blog/blog-headline.vue';
import { useHeaderStore } from '@/stores/header';

const { page } = defineProps({
    page: {
        type: Object,
        required: true,
    },
});

const headerStore = useHeaderStore();
onMounted(() => { headerStore.altLogo++; });
onUnmounted(() => { headerStore.altLogo--; });
</script>

<template>
    <div class="template-blog-hero treat-as-hero pt-[97px] lg:pt-[150px]">
        <div>
            <ProjectBreadcrumbs light />
            <BlogHeadline :page="page" />
            <MessImage :key="page.data.image" :src="page.data.image" :alt="page.data.title" class="hero" />
        </div>
    </div>
</template>

<style>
/* [child] — MessImage border-radius and sizing */
.template-blog-hero .mess-image {
    border-radius: var(--radius);
    overflow: hidden;
    max-width: 1130px;
    margin: 0 auto;
}

/* [child] — h2 inside BlogHeadline */
.template-blog-hero h2 {
    font-family: var(--hubspot-serif);
    font-weight: 400;
}
</style>
